import React from 'react';
import {Link} from 'gatsby';

import slugify from '../utils/slugify';
import {getCurrentLocale} from "./getCurrentLocale";

import sidebarStyles from '../components/sidebar/Sidebar.module.scss'

export const createLinkDocs = ({isActive, id, item, location}) => {
    let locale = getCurrentLocale(location.pathname);

    return (
        <Link className = {isActive ? sidebarStyles.sidebarLinkActive : sidebarStyles.sidebarLink}
              to = {`/${locale}${slugify(item.id, id)}`}>
            {item.title}
        </Link>
    );
};
